const LA = "America/Los_Angeles";
function ymd(iso) {
    const [year, month, day] = iso.split("-");
    return { year: Number(year), month: Number(month), day: Number(day) };
}
export function todayInLosAngeles(now = new Date()) {
    return new Intl.DateTimeFormat("en-CA", {
        timeZone: LA,
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    }).format(now);
}
export function addDays(iso, days) {
    const { year, month, day } = ymd(iso);
    const dt = new Date(Date.UTC(year, month - 1, day + days));
    return dt.toISOString().slice(0, 10);
}
/** Monday on or before `iso` (ISO date, not a timezone-shifted Date). */
export function mondayOnOrBefore(iso) {
    const { year, month, day } = ymd(iso);
    const dow = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
    const back = dow === 0 ? 6 : dow - 1;
    return addDays(iso, -back);
}
export function firstOfMonth(iso) {
    return `${iso.slice(0, 7)}-01`;
}
export function lastOfMonth(iso) {
    const { year, month } = ymd(iso);
    const dt = new Date(Date.UTC(year, month, 0));
    return dt.toISOString().slice(0, 10);
}
/** Visible cells for the current view: Mon–Sun, or the month grid padded to weeks. */
export function visibleRange(view, start) {
    if (view === "week") {
        const monday = mondayOnOrBefore(start);
        return { start: monday, end: addDays(monday, 6) };
    }
    const monthStart = firstOfMonth(start);
    return { start: mondayOnOrBefore(monthStart), end: addDays(mondayOnOrBefore(lastOfMonth(monthStart)), 6) };
}
export function shiftStart(view, start, direction) {
    if (view === "week")
        return addDays(mondayOnOrBefore(start), direction * 7);
    const { year, month } = ymd(firstOfMonth(start));
    const dt = new Date(Date.UTC(year, month - 1 + direction, 1));
    return dt.toISOString().slice(0, 10);
}
export function eachDate(start, end) {
    const days = [];
    for (let cursor = start; cursor <= end; cursor = addDays(cursor, 1))
        days.push(cursor);
    return days;
}
/** Saturday or Sunday, using the ISO date as a calendar day (UTC). */
export function isWeekend(iso) {
    const { year, month, day } = ymd(iso);
    const dow = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
    return dow === 0 || dow === 6;
}
export function formatRangeLabel(view, start, end) {
    const opts = { month: "short", day: "numeric", timeZone: "UTC" };
    const startDate = new Date(`${start}T00:00:00Z`);
    const endDate = new Date(`${end}T00:00:00Z`);
    if (view === "month") {
        return startDate.toLocaleDateString("en-US", { month: "long", year: "numeric", timeZone: "UTC" });
    }
    return `${startDate.toLocaleDateString("en-US", opts)} – ${endDate.toLocaleDateString("en-US", opts)}`;
}
export function formatDayLabel(iso) {
    return new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        timeZone: "UTC"
    });
}
export function resolveAssignees(selected, roster) {
    if (selected === null)
        return roster;
    return selected.filter((name) => roster.includes(name));
}
function readParam(params, key) {
    const value = params[key];
    if (Array.isArray(value))
        return value[0] != null ? String(value[0]) : undefined;
    if (value == null)
        return undefined;
    return String(value);
}
export function parseCalendarQuery(params, today = todayInLosAngeles()) {
    const view = readParam(params, "view") === "month" ? "month" : "week";
    const rawStart = readParam(params, "start");
    const start = rawStart && /^\d{4}-\d{2}-\d{2}$/.test(rawStart)
        ? view === "month"
            ? firstOfMonth(rawStart)
            : mondayOnOrBefore(rawStart)
        : view === "month"
            ? firstOfMonth(today)
            : mondayOnOrBefore(today);
    const rawAssignees = readParam(params, "assignees");
    let selectedAssignees = null;
    if (rawAssignees === "none")
        selectedAssignees = [];
    else if (rawAssignees) {
        selectedAssignees = rawAssignees
            .split(",")
            .map((name) => name.trim())
            .filter(Boolean);
    }
    const rawDay = readParam(params, "day");
    const day = rawDay && /^\d{4}-\d{2}-\d{2}$/.test(rawDay) ? rawDay : null;
    return {
        view,
        start,
        includeBlocked: readParam(params, "blocked") === "1",
        includeDone: readParam(params, "done") === "1",
        includeWeekends: readParam(params, "weekends") === "1",
        selectedAssignees,
        day
    };
}
export function serializeCalendarQuery(query) {
    const params = {
        view: query.view,
        start: query.start
    };
    if (query.includeBlocked)
        params.blocked = "1";
    if (query.includeDone)
        params.done = "1";
    if (query.includeWeekends)
        params.weekends = "1";
    if (query.selectedAssignees === null) {
        /* omit — all assignees */
    }
    else if (query.selectedAssignees.length === 0) {
        params.assignees = "none";
    }
    else {
        params.assignees = query.selectedAssignees.join(",");
    }
    if (query.day)
        params.day = query.day;
    return params;
}
//# sourceMappingURL=calendar.js.map